/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable max-len */
/* eslint-disable max-lines-per-function */
import React, { useState } from "react";
import { Button, Col, Form, Input, Row, Space, Typography } from "antd";
import Heading from "components/Common/Heading/Heading";
import { notificationController } from "components/Common/Notification/Notification";
import { ChangePasswordData } from "interfaces/ApiInterface/ILoginFormData";
import { changePassword } from "api/services/userAuth.api";
import { useAppSelector } from "hooks/reduxHooks";

const { Text } = Typography;

const ChangePassword: React.FC = () => {
  const [form] = Form.useForm();
  const userString = localStorage.getItem("UserRecord");
  const userName = userString ? JSON.parse(userString) : null;
  const [isLoading, setLoading] = useState(false);
  const lockerDetails: any = useAppSelector((state) => state.landingPage.lockerPortalDetails);

  const handleSubmit = async (values: {
    currentPassword: string;
    newPassword: string;
    confirm: string;
  }) => {
    setLoading(true);
    if (values.currentPassword === values.newPassword) {
      notificationController.error({
        message: "New password must be different from the current password.",
      });
      setLoading(false);
      return;
    }

    const data: ChangePasswordData = {
      PortalId: lockerDetails?.lockerPortalDetails?.PortalId,
      User: {
        Username: btoa(userName?.UserName),
        Password: values?.currentPassword,
        NewPassword: values?.newPassword,
      },
    };

    changePassword(data)
      .then(() => {
        setLoading(false);
        notificationController.success({
          message: "Password changed successfully.",
        });
        form.resetFields();
      })
      .catch((error) => {
        const errorMessage = error?.response?.data?.ErrorMessage || "An unexpected error occurred.";
        notificationController.error({
          message: errorMessage,
        });
        setLoading(false);
      });
  };

  return (
    <Row gutter={15} className="profile-form-container">
      <Col span={12} xs={24} md={12} lg={12} xxl={12}>
        <Space direction="vertical" size={"middle"}>
          <Heading titleText="Change Password" titleClass="change-password" />
          <Text className="new-registration-info">
            Use the form below to change your password. You will use your new password the next time
            you login.
          </Text>
          <div className="form-wrapper">
            <Form
              form={form}
              layout="vertical"
              name="changePassword"
              onFinish={handleSubmit}
              initialValues={{ remember: true }}
              autoComplete="off"
            >
              <Form.Item
                label={
                  <span className="wrapper">
                    Current Password <span className="text-danger">*</span>
                  </span>
                }
                name="currentPassword"
                rules={[{ required: true, message: "This field cannot be left blank." }]}
                className="input-label"
              >
                <Input.Password className="form-input" />
              </Form.Item>
              <Form.Item
                label={
                  <span className="wrapper">
                    New Password <span className="text-danger">*</span>
                  </span>
                }
                name="newPassword"
                rules={[
                  () => ({
                    validator(_, value) {
                      if (!value) {
                        return Promise.reject(new Error("This field cannot be left blank."));
                      }
                      if (
                        (value && value.length < 6) ||
                        !/^(?=.*[0-9])(?=.*[a-zA-Z])[a-zA-Z0-9!@#$%^&*(),.?":{}|<>]{8,}$/.test(
                          value
                        )
                      ) {
                        return Promise.reject(
                          new Error("Password must be at least 8 alphanumeric characters and contain at least one number.")
                        );
                      }
                      return Promise.resolve();
                    },
                  }),
                ]}
                className="input-label"
              >
                <Input.Password className="form-input" />
              </Form.Item>
              <Form.Item
                label={
                  <span className="wrapper">
                    Confirm New Password <span className="text-danger">*</span>
                  </span>
                }
                name="confirm"
                dependencies={["newPassword"]}
                rules={[
                  ({ getFieldValue }) => ({
                    validator(_, value) {
                      if (!value) {
                        return Promise.reject(new Error("This field cannot be left blank."));
                      }
                      if (
                        value.length < 8 ||
                        !/^(?=.*[0-9])(?=.*[a-zA-Z])[a-zA-Z0-9!@#$%^&*(),.?":{}|<>]{8,}$/.test(
                          value
                        )
                      ) {
                        return Promise.reject(
                          new Error("Password must be at least 8 alphanumeric characters and contain at least one number.")
                        );
                      }
                      if (!value || getFieldValue("newPassword") !== value) {
                        return Promise.reject(
                          new Error("The two passwords that you entered do not match.")
                        );
                      }
                      return Promise.resolve();
                    },
                  }),
                ]}
              >
                <Input.Password />
              </Form.Item>
              <Button
                type="primary"
                htmlType="submit"
                loading={isLoading}
                className={isLoading ? "btn-disabled registration-btn" : "registration-btn"}
              >
                Reset Password
              </Button>
            </Form>
          </div>
        </Space>
      </Col>
    </Row>
  );
};

export default ChangePassword;
